import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cng-contact-forward',
  templateUrl: 'contact-forward.component.html',
  styleUrls: ['./contact-forward.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactForwardComponent {
  @Input() csr: string;
  @Input() bot: boolean;
  @Input() attachments: any;
  @Input() comment: any;
  @Input() skills: any;
}
